import ReactLoading from "react-loading";

const FullLoading = () => {
    return (
        <ReactLoading type="spin" color="#000" height={'8%'} width={'4%'} className={"position-absolute top-50 start-50"} />
    )
}
export default FullLoading;
